import React, { useEffect, useState } from "react";
import Header from './header/header';
import Sidebar from './sidebar/sidebar';
import PagHome from './contentBody/pagHome';

const MainPage = () => {
    return ( 
        <>
            <div id="wrapper">
                <Sidebar />
                <div className="contentBody">
                    <Header />
                    <PagHome />
                </div>
            </div>
        </>
    )
}
export default MainPage;


